import { BlogArticlePage } from "@/components/blog/blog-pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/registrant/blog/$slug")({
  component: RegistrantBlogArticle,
});

function RegistrantBlogArticle() {
  const { slug } = Route.useParams();
  return (
    <BlogArticlePage
      portal="registrant"
      basePath="/registrant/blog"
      slug={slug}
    />
  );
}
